import React from "react";
import { FormGroup, Input, Button, Form } from "reactstrap";
import { Image } from "antd";

const AddTestimonial = ({
  name,
  setName,
  profession,
  setProfession,
  feedback,
  setFeedback,
  rating,
  setRating,
  addTestimonial,
  updateTestimonial,
  statusupdate,
  handleImage,
  thumbnail,
}) => {
  return (
    <Form role="form">
      {/* Distributor Name */}
      <FormGroup>
        <label className="form-control-label" htmlFor="name">
          Distributor Name
        </label>
        <Input
          className="form-control-alternative"
          id="name"
          placeholder="Enter name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </FormGroup>

      {/* Profession */}
      <FormGroup>
        <label className="form-control-label" htmlFor="profession">
          Profession
        </label>
        <Input
          className="form-control-alternative"
          id="profession"
          placeholder="Enter profession"
          type="text"
          value={profession}
          onChange={(e) => setProfession(e.target.value)}
        />
      </FormGroup>

      {/* Feedback */}
      <FormGroup>
        <label className="form-control-label" htmlFor="feedback">
          Feedback
        </label>
        <Input
          className="form-control-alternative"
          id="feedback"
          placeholder="Enter feedback"
          type="textarea"
          rows="4"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />
      </FormGroup>

      {/* Rating */}
      <FormGroup>
        <label className="form-control-label" htmlFor="rating">
          Rating
        </label>
        <Input
          className="form-control-alternative"
          id="rating"
          placeholder="Enter rating"
          type="number"
          min="1"
          max="5"
          value={rating}
          onChange={(e) => setRating(e.target.value)}
        />
      </FormGroup>

      {/* Image Upload */}
      <FormGroup>
        <label className="form-control-label" htmlFor="image">
          Feedback Featured Image
        </label>
        <Input
          className="form-control-alternative"
          id="image"
          type="file"
          accept="image/*"
          onChange={handleImage}
        />
        {thumbnail && <Image width={200} src={thumbnail} className="mt-3" />}
      </FormGroup>

      {/* Submit Button */}
      {statusupdate ? (
        <Button
          className="my-4 btn-block"
          type="submit"
          color="primary"
          onClick={updateTestimonial}
        >
          Update Testimonial
        </Button>
      ) : (
        <Button
          className="my-4 btn-block"
          type="submit"
          color="primary"
          onClick={addTestimonial}
        >
          Add Testimonial
        </Button>
      )}
    </Form>
  );
};

export default AddTestimonial;
